export const NewsPage = () => {
  return (
    <div className="py-8">
      <div className="px-2 lg:container">Tin tức</div>
    </div>
  );
};
